import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

export default function FinalCTASection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="contato" ref={sectionRef} className="bg-navy py-16 md:py-28 px-4 md:px-6 lg:px-10">
      <div className="max-w-4xl mx-auto text-center">
        <div
          className={`transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="font-cinzel font-bold text-white text-3xl md:text-5xl lg:text-6xl leading-tight">
            Precisa de orientação
            <br />
            em Direito Criminal?
          </h2>
          <p className="font-montserrat font-light text-grey-muted text-base md:text-lg lg:text-xl mt-6 leading-relaxed max-w-2xl mx-auto">
            Fale agora com o advogado e entenda quais caminhos jurídicos podem ser
            avaliados para o seu caso. Atendimento 24 horas para situações urgentes.
          </p>

          <div className="mt-8 md:mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-cta text-navy font-montserrat font-semibold text-sm md:text-base px-8 py-4 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
            >
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center text-lg" />
              Falar com o Advogado no WhatsApp
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-navy-light border border-navy-border flex items-center justify-center">
                <i className="ri-time-line text-grey-light w-4 h-4 flex items-center justify-center" />
              </div>
              <span className="font-montserrat font-light text-grey-light text-sm">
                Atendimento 24h
              </span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-navy-light border border-navy-border flex items-center justify-center">
                <i className="ri-map-pin-line text-grey-light w-4 h-4 flex items-center justify-center" />
              </div>
              <span className="font-montserrat font-light text-grey-light text-sm">
                Sul de Minas
              </span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-navy-light border border-navy-border flex items-center justify-center">
                <i className="ri-shield-check-line text-grey-light w-4 h-4 flex items-center justify-center" />
              </div>
              <span className="font-montserrat font-light text-grey-light text-sm">
                OAB/MG 236.997
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}